import { render, staticRenderFns } from "./BillPayments.vue?vue&type=template&id=24c94555"
import script from "./BillPayments.vue?vue&type=script&lang=js"
export * from "./BillPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports